import React from "react";
import { useTranslation } from "react-i18next";
import { useWizardState } from "../hooks/useWizardState";
import { Input } from "../components/ui/Form/Input";
import { GDPRConsent } from "../components/forms/GDPRConsent";
import { validateEmail } from "../utils/validation";
import { UserIcon } from "../components/icons/UserIcon";
import { EnvelopeIcon } from "../components/icons/EnvelopeIcon";
import { MobileIcon } from "../components/icons/MobileIcon";
import "./Step5Contact.css";

export const Step5Contact: React.FC = () => {
  const { t } = useTranslation();
  const { formData, updateFormData, errors, setFieldError } = useWizardState();

  const handleEmailBlur = () => {
    if (formData.email && !validateEmail(formData.email)) {
      setFieldError("email", t("errors.invalidEmail"));
    } else {
      setFieldError("email", undefined);
    }
  };

  return (
    <div className="step5-contact">
      <h2 className="step-heading">{t("step5.heading")}</h2>

      <div className="form-group">
        <Input
          id="name"
          label={t("step5.name.label")}
          value={formData.name}
          onChange={(e) => {
            updateFormData({ name: e.target.value });
            setFieldError("name", undefined);
          }}
          error={errors.name}
          required
          autoComplete="name"
          prefix={<UserIcon className="w-4.5 h-4.5" />}
          classNames={{
            input: "!pl-[2.25rem]"
          }}
        />

        <Input
          id="email"
          label={t("step5.email.label")}
          type="email"
          value={formData.email}
          onChange={(e) => {
            updateFormData({ email: e.target.value });
            if (errors.email) {
              setFieldError("email", undefined);
            }
          }}
          onBlur={handleEmailBlur}
          error={errors.email}
          required
          autoComplete="email"
          prefix={<EnvelopeIcon className="w-4.5 h-4.5" />}
          classNames={{
            input: "!pl-[2.25rem]"
          }}
        />

        <Input
          id="phone"
          label={t("step5.phone.label")}
          type="tel"
          value={formData.phone || ""}
          onChange={(e) => {
            updateFormData({ phone: e.target.value });
            setFieldError("phone", undefined);
          }}
          error={errors.phone}
          autoComplete="tel"
          prefix={<MobileIcon className="w-4.5 h-4.5" />}
          classNames={{
            input: "!pl-[2.25rem]"
          }}
        />

        <GDPRConsent
          id="gdprConsent"
          checked={formData.gdprConsent}
          onChange={(checked) => {
            updateFormData({ gdprConsent: checked });
            setFieldError("gdprConsent", undefined);
          }}
          error={errors.gdprConsent}
        />
      </div>
    </div>
  );
};

